import { CongressesService } from "@/client";
import { HttpError } from "@/types/error";
import { UseMutationOptions, useMutation } from "@tanstack/react-query";

function useDeleteCongress(
  congressId: string,
  mutationOptions?: UseMutationOptions<void, HttpError, string>,
) {
  return useMutation({
    mutationFn: (name: string) =>
      CongressesService.deleteCongress({
        congressId,
        requestBody: { name },
      }),
    ...mutationOptions,
  });
}

export { useDeleteCongress };
